/*
 * � 2020 Microsoft. All rights reserved.
 */

define(
    'SolitaireShared/CardLogic/CardSuit',{
        "None": 0,
        "Clubs": 1,
        "Diamonds": 2,
        "Hearts": 3,
        "Spades": 4
    }
);
